/* eslint-disable */
/* eslint-disable react/prop-types */
import { useState, useCallback, useEffect, useContext, useRef, Suspense } from "react";
import { useNavigate } from "react-router-dom";
import useRouteParam from "../../../../../hooks/useRouteParam";
import getAgGridHeight from "../../../../../utils/commonFunctions/getAgGridHeight";
import { LazyCustomDialog } from "../../../../shared";
import { ADMIN_DASHBOARD_HEADER } from "../../../../../constants/caption/dashboardHeader";
import { UIContext, AuthContext } from "../../../../../contexts";
import { AgGridColumn, AgGridReact } from "ag-grid-react";
import ROLES from "../../../../../constants/roles";

import { withStyles } from "@material-ui/core/styles";
import { Button, Checkbox, CheckboxProps, Tooltip, IconButton } from "@material-ui/core";
import { green } from "@material-ui/core/colors";

import EditIcon from "@material-ui/icons/Edit";
import { getPermissionsFromGroupOwner } from "../../../../../utils/getPermissionsFromGroupOwner";

const GreenCheckbox = withStyles({
	root: {
		color: "#3A4652",
		"&$checked": {
			color: green[500]
		}
	},
	checked: {}
	// eslint-disable-next-line prettier/prettier
	// eslint-disable-next-line arrow-parens
})((props) => <Checkbox color="default" {...props} size="small" />);

const GroupAllLocationsGrid = ({ locationData }) => {
	// console.log(locationData);

	const [locationDialogProps, setLocationDialogProps] = useState({
		openDialog: false,
		title: "Are you sure you want to disable the location?",
		content: "Then move employees to other location ?",
		actions: [
			{
				label: "Cancel",
				callback: () => {
					setLocationDialogProps(Object.assign({}, locationDialogProps, { openDialog: false }));
				}
			},
			{
				label: "Move Employees",
				callback: () => null
			}
		]
	});
	const queryGroupNumber = useRouteParam("gn");
	const queryLocationNumber = useRouteParam("ln");
	const [selectedRowData, setSelectedRowData] = useState([]);
	const [isRowSelected, setIsRowSelected] = useState(false);
	const [agGridAPI, setAgGridAPI] = useState(null);
	const [agGridColumnAPI, setAgGridColumnAPI] = useState(null);
	const agGridRef = useRef(null);
	const [gridHeight, setGridHeight] = useState("400px");
	const navigate = useNavigate();
	const { user } = useContext(AuthContext);

	const groupLocationsPermission = user
		? getPermissionsFromGroupOwner(user, Number(queryGroupNumber))?.locations_menu.self
		: null;

	const handleAgGridReady = (params) => {
		const { api, columnApi } = params;
		setAgGridAPI(api);
		setAgGridColumnAPI(columnApi);
	};

	const handleFirstDataRendered = (params) => {
		params.api.sizeColumnsToFit();
		params.columnApi.setColumnWidth("action", "100%", true);
		const { api, columnApi } = params;
		api.sizeColumnsToFit();
	};

	const handleOpenLoactionDialog = useCallback(() => {
		setLocationDialogProps(Object.assign({}, locationDialogProps, { openDialog: true }));
	}, [locationDialogProps]);

	const handleSelectionChanged = useCallback(() => {
		const selectedRow = agGridAPI?.getSelectedRows();
		setSelectedRowData(Object.assign([], selectedRow));
		// console.log("selected row", selectedRow);
		if (selectedRow) {
			setIsRowSelected(true);
		} else {
			setIsRowSelected(false);
		}
	}, [agGridAPI]);

	const handleZIPCellRenderer = ({ value }) => {
		let ZIP;
		if (value) {
			ZIP = value.toString();
			if (ZIP.length === 9) ZIP = ZIP.substring(0, 5) + "-" + ZIP.substring(5);
		} else {
			ZIP = "N/A";
		}

		// console.log("Value", value);
		// console.log("ZIP", ZIP);

		return <div>{ZIP}</div>;
	};

	const handleValueCellRenderer = useCallback(({ value }) => {
		return <div>{value ? value : "N/A"}</div>;
	}, []);

	const handleOpenEditLocation = useCallback(
		({ queryGroupNumber, value }) => {
			// console.log("GroupNumber and Location Number", queryGroupNumber, value);
			navigate(`/employer/locations/edit-location?gn=${queryGroupNumber}&ln=${value}`);
		},
		[navigate]
	);

	const handleEditActionButtonRender = useCallback(
		({ queryGroupNumber, value }) => {
			if (groupLocationsPermission && groupLocationsPermission.update) {
				return (
					<Tooltip title="Edit Location" leaveDelay={500} enterDelay={200} arrow>
						<IconButton onClick={() => handleOpenEditLocation({ queryGroupNumber, value })}>
							<EditIcon />
						</IconButton>
					</Tooltip>
				);
			} else {
				return <></>;
			}
		},
		[handleOpenEditLocation, groupLocationsPermission]
	);

	const handleActionDisabledCellRender = useCallback(
		(value) => {
			// console.log("Value", value);
			return <GreenCheckbox checked={value.data.disabled} onChange={handleOpenLoactionDialog} />;
		},
		[handleOpenLoactionDialog]
	);

	useEffect(() => {
		const _gridHeight = getAgGridHeight(locationData.length);
		setGridHeight(_gridHeight);
	}, [locationData.length]);

	return (
		<>
			<Suspense fallback={<div />}>
				<LazyCustomDialog dialogProps={locationDialogProps} />
			</Suspense>
			<div className="all-location-grid-container">
				<div className="ag-theme-alpine" style={{ height: gridHeight, width: "100%" }}>
					<AgGridReact
						ref={agGridRef}
						rowData={locationData}
						onGridReady={handleAgGridReady}
						onFirstDataRendered={handleFirstDataRendered}
						rowSelection={"multiple"}
						onSelectionChanged={handleSelectionChanged}
						animateRows
						suppressColumnVirtualisation={true}
						defaultColDef={{
							filter: "agTextColumnFilter",
							floatingFilter: true,
							resizable: true
						}}
						frameworkComponents={{
							handleActionDisabledCellRender: handleActionDisabledCellRender,
							handleEditActionButtonRender: handleEditActionButtonRender,
							handleValueCellRenderer: handleValueCellRenderer,
							handleZIPCellRenderer: handleZIPCellRenderer
						}}
					>
						{user &&
							user.role === ROLES.super_admin &&
							((user.first_name === "Chitrak" && user.last_name === "Biswas") ||
								(user.first_name === "Anupam" && user.last_name === "Biswas") ||
								(user.first_name === "Rahul" && user.last_name === "Dutta") ||
								(user.first_name === "Suman" && user.last_name === "Dutta")) ? (
							<AgGridColumn
								field="group_number"
								headerName="Group Number"
								floatingFilterComponentParams={{ suppressFilterButton: true }}
								suppressSizeToFit
							></AgGridColumn>
						) : null}
						<AgGridColumn
							field="location_number"
							headerName="Location Number"
							floatingFilterComponentParams={{ suppressFilterButton: true }}
							suppressSizeToFit={true}
						></AgGridColumn>
						<AgGridColumn
							field="location_name"
							headerName="Location Name"
							floatingFilterComponentParams={{ suppressFilterButton: true }}
							suppressSizeToFit={true}
						></AgGridColumn>
						{/* <AgGridColumn
							field="location_status"
							headerName="Location Status"
							floatingFilterComponentParams={{ suppressFilterButton: true }}
							suppressSizeToFit={true}
						></AgGridColumn> */}
						<AgGridColumn
							field="EMAIL"
							headerName="Email"
							floatingFilterComponentParams={{ suppressFilterButton: true }}
							cellRenderer="handleValueCellRenderer"
						// suppressSizeToFit
						></AgGridColumn>
						<AgGridColumn
							field="PHONE"
							headerName="Phone Number"
							floatingFilterComponentParams={{ suppressFilterButton: true }}
							cellRenderer="handleValueCellRenderer"
						// suppressSizeToFit
						></AgGridColumn>
						<AgGridColumn
							field="ADDR1"
							headerName="Address Line 1"
							floatingFilterComponentParams={{ suppressFilterButton: true }}
							cellRenderer="handleValueCellRenderer"
						// suppressSizeToFit
						></AgGridColumn>
						<AgGridColumn
							field="ADDR2"
							headerName="Address Line 2"
							floatingFilterComponentParams={{ suppressFilterButton: true }}
							cellRenderer="handleValueCellRenderer"
						// suppressSizeToFit
						></AgGridColumn>
						<AgGridColumn
							field="CITY"
							headerName="City"
							floatingFilterComponentParams={{ suppressFilterButton: true }}
							cellRenderer="handleValueCellRenderer"
						// suppressSizeToFit
						></AgGridColumn>
						<AgGridColumn
							field="STATE"
							headerName="State"
							floatingFilterComponentParams={{ suppressFilterButton: true }}
							cellRenderer="handleValueCellRenderer"
						// suppressSizeToFit
						></AgGridColumn>
						<AgGridColumn
							field="ZIPCODE"
							headerName="ZIP"
							floatingFilterComponentParams={{ suppressFilterButton: true }}
							cellRenderer="handleZIPCellRenderer"
							suppressSizeToFit
						></AgGridColumn>
						<AgGridColumn
							field="location_number"
							headerName="Edit Location"
							suppressSizeToFit={true}
							cellRenderer="handleEditActionButtonRender"
							cellRendererParams={{
								queryGroupNumber: queryGroupNumber
							}}
							filter={false}
						></AgGridColumn>
						{/* ) : null } */}
						{/* {tabLabel === "active" ? (
							<AgGridColumn
								field="action"
								headerName="Disabled"
								cellRenderer="handleActionDisabledCellRender"
								suppressSizeToFit={true}
								filter={false}
							></AgGridColumn>
						) : null} */}
					</AgGridReact>
				</div>
			</div>
		</>
	);
};

export default GroupAllLocationsGrid;
